import { createSelector } from 'reselect';
const organizationsStateSelector = ({ entities: { organizations } = {} }) =>
  organizations;

export const getOrganization = createSelector(
  [organizationsStateSelector, (_, { id }) => id],
  (organizations, id) => {
    return (organizations || {})[id];
  }
);



// WEBPACK FOOTER //
// ./src/App/account/selectors/organizations/index.js